<script>
    import GPDetails from "./gp-details.svelte";
    import {getGPTransFunc} from "./gp-translations.js";
    import {preferredNames} from "./gp";
    let trans = getGPTransFunc("gp-itemdetails");

    export let type;
    let inside;
    let description;
    let bigimgsrc;

    export function open() {
        bigimgsrc = type.thumbUrl;
        let parts = bigimgsrc.split('\\');
        bigimgsrc = parts.join('\\\\');

        description = "";
        let plantTypes = {};
        type.plants.forEach(e => {
            let t = GP.plantTypesById[e.itemInstance.typeId];
            if (plantTypes[t.id])
                plantTypes[t.id].count += 1;
            else
                plantTypes[t.id] = {
                    type: t,
                    count: 1
                };
        })
        for (const [key, value] of Object.entries(plantTypes)) {
            let displayName = $preferredNames === "latin" ? value.type.latin : value.type.name;
            description += "<tr>";
            description += "<td>" + value.count + "x</td>";
            description += "<td>" + displayName +  "</td>";
//            if (value.type["-ar"] && value.type["-arm"] )
//                description += "<td>" + value.type["-ar"] + "-" + value.type["-arm"]  +  "</td>";
            description += "</tr>";
        }

        inside.open();
    }

</script>

<GPDetails type="{type}" bind:this={inside}>
    <div class="thumbarea">
        <div class="thumb" style="background-image: url({bigimgsrc});"/>
    </div>
    <div class="description">
        <table>
            <tr>
                <th></th>
                <th>{trans("Plant name")}</th>
            </tr>
            {@html description}
        </table>
    </div>
</GPDetails>